import React, { useEffect, useState } from 'react'
import Input from 'components/ui/dataEntry/inputs/Input'
import { Col, Modal, Row, Switch } from 'antd'
import { SPECIAL_CHARACTER_REGEX } from 'constants/general-constants'
import './CreateFilesModal.scss'

const CreateFilesModal = ({
  visible,
  onOk,
  onCancel,
  loading,
  isEditMode = false,
  fieldData
}) => {
  const [name, setName] = useState('')
  const [extension, setExtension] = useState('')
  const [isEnabled, setIsEnabled] = useState(false)
  const resetForm = () => {
    setName('')
    setExtension('')
    setIsEnabled(false)
  }
  const setFormValues = (fieldData) => {
    const { name, extension, isEnabled } = fieldData
    setName(name)
    setExtension(extension)
    setIsEnabled(isEnabled)
  }
  useEffect(() => {
    resetForm()
  }, [visible])
  useEffect(() => {
    if (isEditMode) {
      // console.log('edit fielddata', fieldData)
      setFormValues(fieldData)
    }
  }, [isEditMode, fieldData])
  const isSubmitButtonDisabled = (name, extension) => {
    const nameHasSpecialCharacters = !SPECIAL_CHARACTER_REGEX.test(name)
    const extensionHasSpecialCharacters = !SPECIAL_CHARACTER_REGEX.test(extension)
    if (nameHasSpecialCharacters || extensionHasSpecialCharacters || !name || !extension) return true
    return false
  }
  return (
    <Modal
      title={`${isEditMode ? 'Edit' : 'Create'} File Type`}
      visible={visible}
      onOk={() => {
        onOk({
          name,
          extension,
          isEnabled
        })
      }}
      onCancel={() => onCancel(resetForm)}
      className='general-modal create-file-modal'
      okButtonProps={{
        loading,
        disabled: isSubmitButtonDisabled(name, extension)
      }}
    >
      <Row gutter={[24, 24]}>

        <Col span={24}>
          <Input
            title='Name'
            placeholder='Name'
            inputName='name'
            isRequired
            value={name}
            handleChange={(e) => {
              setName(e.target.value)
            }}
            // isError={!name}
            // errorMessage={!title ? 'Invalid Device ID' : ''}
          />
        </Col>

        <Col span={24}>
          <Input
            title='Extension'
            placeholder='Enter Extension'
            inputName='extension'
            isRequired
            value={extension}
            handleChange={(e) => {
              setExtension(e.target.value)
            }}
            // isError={!extension}
            // errorMessage={title && !isDeviceIdValid ? 'Invalid Device ID' : ''}
            readOnly={isEditMode}
          />
        </Col>
        <Col span={24} className='enabled-input'>
          <p>Active</p>
          <Switch
            checked={isEnabled}
            onChange={(flag) => setIsEnabled(flag)}
            // disabled={isEditMode}
          />
        </Col>
      </Row>
    </Modal>
  )
}

export default CreateFilesModal
